<template>
	<div class="body_height">
		<!-- 轮播 -->
		<swiper></swiper>
		<div class="content">
			<div class="el-row--flex is-justify-space-around index_menu is-align-middle" v-if="indexNum">
				<div class="m_l">
					<img src="../../assets/image/home/home_nav1.png" alt="">
					<div>发布文章与作品
						<div class="count_num">
							<countTo :startVal='0' :endVal='indexNum.workCount' :duration='3000' separator=",">
							</countTo>
						</div>
					</div>
				</div>
				<div class="m_l">
					<img src="../../assets/image/home/home_nav2.png" alt="">
					<div>收录IP形象条目
						<div class="count_num">
							<countTo :startVal='0' :endVal='indexNum.ipCount' :duration='3000' separator=","></countTo>
						</div>
					</div>
				</div>
				<div class="m_l">
					<img src="../../assets/image/home/home_nav3.png" alt="">
					<div>
						矩阵阅读曝光量
						<div class="count_num">
							<countTo :startVal='0' :endVal='indexNum.ipViewCount' :duration='3000' separator=",">
							</countTo>
						</div>
					</div>

				</div>

				<div class="m_l">
					<img src="../../assets/image/home/home_nav4.png" alt="">
					<div>行业设计师精准人群
						<div class="count_num">
							<countTo :startVal='0' :endVal='indexNum.userCount' :duration='3000' separator=",">
							</countTo>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 赛事活动 -->
		<events></events>
		<!-- 探索发现 -->
		<discovery></discovery>
		<!-- 精选IP形象 -->
		<appearance></appearance>

		<!-- 精选作品 -->
		<selectedWorks></selectedWorks>
		<!-- 最新资讯 -->
		<homeNews></homeNews>

		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import countTo from 'vue-count-to';
	import appearance from './component/Appearance.vue'
	import discovery from './component/Discovery/Discovery.vue'
	import events from './component/Events/Events.vue'
	import homeNews from './component/HomeNews.vue'
	import selectedWorks from './component/SelectedWorks.vue'
	import swiper from './component/Swiper.vue'
	import loading from '@/components/Loading.vue'
	export default {
		name: 'home',
		components: {
			events,
			swiper,
			appearance,
			discovery,
			homeNews,
			selectedWorks,
			countTo,
			loading
		},
		data() {
			return {
				dataList: [],
				indexNum: null,
				isLoading: true
			};
		},
		created() {
			this.$store.commit('changeSearchStatic', false)
			this.getNum()

		},
		methods: {
			async getNum() {
				const res = await this.$axios.get('/front/statistics')
				this.indexNum = res.data
				this.isLoading = false
			},
			// toto(ipid) {
			// 	this.$router.push({
			// 		path: "discovery",
			// 		params: {
			// 			ipId: ipid
			// 		}
			// 	})
			// }
		}
	}
</script>
<style lang="scss" scoped>
	.index_menu {
		background-color: var(--white);
		margin-top: -60px;
		position: relative;
		z-index: 2;
		padding: 30px 20px;
		border-radius: 10px;
		box-shadow: 0 0 8px rgba(0, 0, 0, .05);
		display: flex;
		justify-content: space-between;

		.m_l {
			border-right: 1px solid #ddd;
			padding-left: 3%;
			display: flex;
			flex: 1;

			img {
				width: 60px;
				height: 60px;
				margin-right: 10px;
			}

			&:last-child {
				border-right: 0;
			}


		}

	}



	.ssht-more {
		text-align: center;
		padding: 20px;
	}

	.ts-bg {
		background-color: var(--white);
	}

	.count_num {
		font-weight: bold;
		font-size: 24px;
		color: var(--info);
	}
</style>
